import myUtil from '@/util'
import $moment from 'moment'

import { defaultApi } from '@/plugins/api/defaultApi'
// 사입
const PURCHASE_TYPE = 'purchase_list'
// 매출
const SALES_TYPE = 'sales_list'
// 외상
const CREDIT_TYPE = 'tab'

const defaultProduct = function () {
  const uuid = null
  const thumbnailUrl = ''
  const title = null
  const option = ''
  const requestType = 'purchase'
  const titleForPurchase = ''
  const quantity = 1
  const purchaseUnitCost = 0
  const memo = ''
  const reference = null
  const wholesaler = {
    uuid: null,
    name: null,
  }
  const mall = {
    uuid: 'ADDITION',
    providerName: '추가입력',
    provider: '추가입력',
  }
  const saleses = []
  const credits = []

  function getTotalAmount() {
    return this.quantity * this.purchaseUnitCost
  }

  function validNumberFields() {
    return this.quantity > 0 && this.purchaseUnitCost > 0
  }

  function isValid() {
    const hasTitle = !!this.title
    const hasType = !!this.requestType
    const hasWholesaler = !!this.wholesaler?.uuid
    return hasTitle && hasType && hasWholesaler && this.validNumberFields()
  }

  return {
    uuid,
    thumbnailUrl,
    title,
    option,
    requestType,
    titleForPurchase,
    quantity,
    purchaseUnitCost,
    memo,
    reference,
    wholesaler,
    mall,
    saleses,
    credits,
    getTotalAmount,
    validNumberFields,
    isValid,
  }
}

export default {
  name: 'product',
  namespaced: true,
  state: {
    serviceStartHour: 17,
    status: {
      // display는 CreditDisplay.vue 보여줄 화면
      IS_WAITING: {
        display: 'waiting',
        desc: '16시부터 19시까지 사이 정산시간',
      },
      NOT_SCRAPED_YET: {
        display: 'not_scraped',
        desc: '아직 스크래핑을 안함',
      },
      NO_DATA: {
        display: 'empty',
        desc: '쇼핑몰 스크래핑은 완료했으나 데이터가 없음',
      },
      CLOSED: {
        display: 'closed',
        desc: '오늘 신청 완료했음',
      },
      CLOSED_WITH_FILES: {
        display: 'closed',
        desc: '오늘 신청 완료했음 (파일업로드로)',
      },
    },
    products: null,
    requiredFields: [
      {
        name: 'title',
        isNumber: false,
        subField: 'titleForPurchase',
      },
      {
        name: 'titleForPurchase',
        isNumber: false,
        subField: 'title',
      },
      {
        name: 'quantity',
        isNumber: true,
        subField: null,
      },
    ],
  },
  getters: {
    getServiceStartHour(state) {
      return state.serviceStartHour
    },
    getStatus(state) {
      return state.status
    },
    getRequiredFields(state) {
      return state.requiredFields
    },
  },
  mutations: {
    setProducts(state, products) {
      state.products = products
    },
  },
  actions: {
    setDefaultValue({}, item) {
      const defaultValue = defaultProduct()

      if (!item?.uuid) {
        defaultValue.uuid = 'ADDITION_' + myUtil.uuid()
      }

      Object.keys(defaultValue)
        .filter((k) => !item?.[k] && defaultValue.hasOwnProperty(k))
        .forEach((k) => (item[k] = defaultValue[k]))

      return item
    },
    async initCredits({ dispatch, rootGetters }, products) {
      const resultSet = {}

      const service = rootGetters['contract/isServiceAvailable']

      for (let index = 0; index < products.length; index++) {
        const item = products[index]
        const mallId = item.mall.uuid

        if (resultSet[mallId]) {
          resultSet[mallId]['items'].push(item)
        } else {
          const temp = {
            ...item.mall,
            items: [],
          }
          temp.items.push(item)
          resultSet[mallId] = temp
        }
      }

      if (service === true) {
        const mallsObj = rootGetters['mall/mallsObj']

        for (const key in mallsObj) {
          const mall = mallsObj[key]
          const isOK = await dispatch('contract/isCompleted', mall.provider, { root: true })
          if (isOK === false) {
            delete resultSet[mall.uuid]
          }
        }
      }

      return resultSet
    },
    async getProducts({ commit }, queryObj) {
      const { data } = await defaultApi.getProducts(queryObj)
      commit('setProducts', data.results)
      return data
    },
    async getProductsDetail({ dispatch }, uuid) {
      const { data } = await defaultApi.getProductsDetail(uuid)
      data?.itemSet.forEach((item) => {
        dispatch('setDefaultValue', item)
      })
      return data
    },
    async removeProductsDetail({}, uuid) {
      const data = await defaultApi.removeProductsDetail(uuid)
      return data
    },
    async productsDetailDownloadExcel({}, { uuid, fileName }) {
      await defaultApi.getProductsDetailDownloadExcel(uuid, fileName)
    },
    async confirmPurchases({}, uuid) {
      const { data } = await defaultApi.postProductsDetailConfirm(uuid)
      return data
    },
    async getPurchasesDetail({ dispatch }, queryObj) {
      const { results } = await dispatch('getProducts', queryObj)
      if (results.length == 0) {
        return
      }
      const purchases = results.filter((r) => r.type === PURCHASE_TYPE)
      if (purchases.length > 0) {
        return dispatch('getProductsDetail', purchases[0].uuid)
      }
      const saleses = results.filter((r) => r.type === SALES_TYPE)
      return dispatch('getProductsDetail', saleses[0].uuid)
    },
    async addPurchases({}, param) {
      param['type'] = PURCHASE_TYPE

      const { data } = await defaultApi.postProducts(param)

      return data
    },
    async confirmCredits({}, uuid) {
      const { data } = await defaultApi.postProductsDetailStatus({ uuid, status: 'request' })
      return data
    },
    async cancelCredits({}, uuid) {
      const { data } = await defaultApi.postProductsDetailStatus({ uuid, status: 'cancel' })
      return data
    },
    async getCreditsDetail({ dispatch }, queryObj) {
      const { results } = await dispatch('getProducts', queryObj)
      if (results.length == 0) {
        return
      }
      const credits = results.filter((r) => r.type === CREDIT_TYPE)
      if (credits.length > 0) {
        return dispatch('getProductsDetail', credits[0].uuid)
      }

      const purchases = results.filter((r) => r.type === PURCHASE_TYPE)
      if (purchases.length > 0) {
        return dispatch('getProductsDetail', purchases[0].uuid)
      }

      const saleses = results.filter((r) => r.type === SALES_TYPE)
      return dispatch('getProductsDetail', saleses[0].uuid)
    },
    async getCreditsDetailObj({ dispatch }, queryObj) {
      const files = await dispatch('getProductFiles', queryObj)
      if (files?.length > 0) {
        return 'CLOSED_WITH_FILES'
      }

      const { results } = await dispatch('getProducts', queryObj)
      if (results.length == 0) {
        return 'NOT_SCRAPED_YET'
      }

      const done = results.some((r) => r.status !== 'saved')
      if (done === true) {
        return 'CLOSED'
      }

      await dispatch('contract/getContracts', null, { root: true })
      const saleses = results.filter((r) => r.type === SALES_TYPE)
      let salesResult = { itemSet: [] }
      if (saleses.length > 0) {
        salesResult = await dispatch('getProductsDetail', saleses[0].uuid)
      }
      const origins = await dispatch('initCredits', salesResult.itemSet)

      const credits = results.filter((r) => r.type === CREDIT_TYPE)
      if (credits.length > 0) {
        const creditsResult = await dispatch('getProductsDetail', credits[0].uuid)
        const cr = await dispatch('initCredits', creditsResult.itemSet)

        const temp = { ...cr }
        if (temp?.['ADDITION']) {
          delete temp['ADDITION']
        }

        if (Object.keys(origins).length != Object.keys(temp).length) {
          //키가 브랜드가 추가되면 새로 저장
          const mergeObj = Object.assign(origins, temp)
          let itemSet = []
          for (const k in mergeObj) {
            itemSet = itemSet.concat(mergeObj[k])
          }

          await dispatch('addCredits', {
            date: queryObj.date,
            type: CREDIT_TYPE,
            itemSet,
          })

          return await dispatch('getCreditsDetailObj', queryObj)
        }
        return {
          origin: creditsResult,
          obj: cr,
        }
      } else {
        // 최초 아무것도 없을때 강제로 저장
        await dispatch('addCredits', {
          date: queryObj.date,
          type: CREDIT_TYPE,
          itemSet: salesResult.itemSet,
        })

        return await dispatch('getCreditsDetailObj', queryObj)
      }
    },
    async getConfirmedCredits({ dispatch }, queryObj) {
      const { results } = await dispatch('getProducts', queryObj)
      if (results.length == 0) {
        return
      }

      const done = results.filter((r) => r.status !== 'saved')
      if (done.length == 0) {
        return
      }

      const doneResult = await dispatch('getProductsDetail', done[0].uuid)
      const values = await dispatch('initCredits', doneResult.itemSet)

      return {
        origin: doneResult,
        obj: values,
      }
    },
    async addCredits({}, credit) {
      delete credit.uuid
      delete credit.status

      for (let i = 0; i < credit.itemSet.length; i++) {
        // null인경우 삭제
        if (credit.itemSet[i].wholesaler) {
          delete credit.itemSet[i].wholesaler
        }

        if (!credit.itemSet[i].reference) {
          credit.itemSet[i].reference = credit.itemSet[i].uuid
        }

        delete credit.itemSet[i].uuid
      }

      const { data } = await defaultApi.postProducts(
        Object.assign(credit, {
          type: CREDIT_TYPE,
        }),
      )
      return data
    },
    async addProductItem({}, { listUUID, product }) {
      product.list = listUUID
      const { data } = await defaultApi.postProductItem(product)

      return data
    },
    async modifyProductItem({}, product) {
      const { data } = await defaultApi.putProductItem(product.uuid, product)

      return data
    },
    async removeProductItem({}, uuid) {
      const { data } = await defaultApi.deleteProductItem(uuid)

      return data
    },
    getNowProductDate({ state }) {
      const date = $moment(Date.now())
      if (date.hour() < state.serviceStartHour) {
        date.subtract(1, 'days')
      }
      return date.format('yyyy-MM-DD')
    },
    async addProductFile({}, file) {
      const { data } = await defaultApi.postProductListFiles(file)
      return data
    },
    async deleteProductFile({}, { uuid }) {
      const { data } = await defaultApi.deleteProductListFiles({ uuid })
      return data
    },
    async getProductFiles({}, { date }) {
      const {
        data: { results },
      } = await defaultApi.getProductListFiles({ date })
      return results
    },
  },
}
